import { Col, Nav, Row } from "react-bootstrap";

interface Tab {
  key: string;
  label: JSX.Element;
  children?: Tab[];
}

interface Props {
  selectedTab: string;
  onTabChange: (tab: string) => void;
  tabs: Tab[];
  bsClass?: string;
  children: JSX.Element;
}

const Tabs = ({ selectedTab, onTabChange, tabs, children, bsClass = "mb-5" }: Props) => {
  const flattenTabs = (tabs: Tab[]): Tab[] => {
    return tabs.reduce((acc, tab) => {
      acc.push(tab);
      if (tab.children) {
        acc.push(...flattenTabs(tab.children));
      }
      return acc;
    }, [] as Tab[]);
  };

  const flatTabs = flattenTabs(tabs);
  const tab = flatTabs.find((tab) => tab.key === selectedTab);
  const parentTab = tabs.find((tab) => tab.children?.some((child) => child.key === selectedTab));
  const childTabs = parentTab?.children || [];

  return (
    <Row>
      <Col className={`mt-5 ph-5 border-bottom fs-standard ${bsClass}`} xs={12}>
        <Nav
          variant="underline"
          onSelect={(key) => {
            if (key) {
              const selectedTab = tabs.find((tab) => tab.key === key);
              // If the tab has children, select the first child
              if (selectedTab && selectedTab.children?.[0]?.key) {
                onTabChange(selectedTab.children[0].key);
              } else {
                onTabChange(key);
              }
            }
          }}
          activeKey={parentTab?.key || tab?.key}
        >
          {tabs.map(({ key, label }) => {
            return (
              <Nav.Item key={key}>
                <Nav.Link eventKey={key} style={{ whiteSpace: "nowrap" }}>
                  {label}
                </Nav.Link>
              </Nav.Item>
            );
          })}
        </Nav>
      </Col>
      {childTabs.length > 1 && (
        <Col className="fs-standard" style={{ borderRight: "1px solid #ccc" }} xs={12} md={2}>
          <div className="pt-2"></div>
          <Nav
            variant="underline"
            onSelect={(tab) => {
              if (tab) {
                onTabChange(tab);
              }
            }}
            activeKey={selectedTab}
            className="flex-column text-xs-center text-md-start"
          >
            {childTabs.map(({ key, label }) => {
              return (
                <Nav.Link eventKey={key} key={key} className="text-xs-center text-md-start py-2">
                  {label}
                </Nav.Link>
              );
            })}
          </Nav>
        </Col>
      )}
      <Col xs={12} md={childTabs.length > 1 ? 10 : 12}>
        {children}
      </Col>
    </Row>
  );
};

export default Tabs;
